"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["tag", "fontSize", "fontWeight"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Header = function Header(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? "h2" : _ref$tag,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 7 : _ref$fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? 2 : _ref$fontWeight,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    fontSize: fontSize,
    fontWeight: fontWeight,
    tag: tag
  }, props));
};

Header.propTypes = {
  // fontSize: Font size
  fontSize: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
  // fontSize: Font weight
  fontWeight: _propTypes.number,
  // tag: Type of tag
  tag: _propTypes.string
};
Header.displayName = "Modules.Header";
var _default = Header;
exports["default"] = _default;